import React from 'react';
import { Spinner } from '../spinner/Spinner.js';
import styles from './AppLoading.module.css';

export function AppLoading() {
  return (
    <div className={styles.loadingContainer}>
      <div className={styles.loadingSpinner}>
        <Spinner size={240} grain />
      </div>
    </div>
  );
}

export default AppLoading;
